<template>
    <div class="wrap">
        <listHeader
            :title="postData.chid > 0 ? '编辑课程' : '新增课程'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="类型"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-select
                                    v-decorator="['type', {required: true, rules: [{ message: '选择课程类型' }], initialValue: ''}]">>
                                    <a-select-option value="">选择课程类型</a-select-option>
                                    <a-select-option v-for="(item, key) in config.type" :key="key" :value="key">
                                        {{ item }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="课程名称"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入课程名称" v-decorator="['chname', {rules: [{ required: true, max: 64, message: '请输入课程名称' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                label="课时"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入课时" v-decorator="['time', {rules: [{ required: true, message: '请输入课时' }], initialValue: ''}]" suffix="小时"/>
                            </a-form-item>

                            <a-form-item
                                label="网址"
                                v-bind="formItemLayout"
                            >
                                <a-input placeholder="请输入网址，线上课程时填写" v-decorator="['url', {rules: [{ required: false, max: 128, message: '请输入网址，线上课程时填写' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                label="课程介绍"
                                v-bind="formItemLayout"
                            >
                                <a-textarea
                                    v-decorator="['remark',{rules: [{ required: false, max: 128, message: '请填写课程介绍' }]} ]"
                                    placeholder="请填写课程介绍"
                                    :auto-size="{ minRows: 2 }"
                                />
                            </a-form-item>

                            <a-form-item
                                label="排序"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入排序值，整数、顺序排列" v-decorator="['ordernum', {rules: [{ required: true, message: '请输入排序值，整数、顺序排列' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';

export default {
    components: {
        listHeader,
    },
    data() {
        return {
            scenario: 'lchapterCreate',
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'lmid': '',
                'chid': '',
            },
            data: {},
            config: {},
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/lchapter/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.chid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            type: res.data.type,
                            chname: res.data.chname,
                            time: res.data.time,
                            url: res.data.url,
                            remark: res.data.remark,
                            ordernum: res.data.ordernum,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.chid > 0) {
                            url = '/manage/lchapter/edit';
                            values.chid = this.postData.chid;
                        } else {
                            url = '/manage/lchapter/save';
                            values.lmid = this.postData.lmid;
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                this.$router.go(-1);
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
